import { Component, OnInit } from '@angular/core';
import { JarwisService } from '../../Services/jarwis.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/Services/auth.service';
import { TokenService } from 'src/app/Services/token.service';

@Component({
  selector: 'app-cambiar-password',
  templateUrl: './cambiar-password.component.html',
  styleUrls: ['./cambiar-password.component.scss']
})
export class CambiarPasswordComponent implements OnInit {

  public form ={
    email: null,
    password: null,
    password_confirmation:null
  }

  publicformAfterValidation ={
    email:null,
    password:null
  }
  public errorCambiarPassword= null;

  public error = null;
  errorCorreo = null;
  errorTipoCorreo= null;
  errorPasswordMatch = null;

  constructor(
    private Jarwis:JarwisService,  
    private router :Router,
    private Auth:AuthService,
    private Token:TokenService,
  ) { }

  ngOnInit() {
  }
  visibility(visibility,visibilityIcon){ 
    const mostrar_password = document.querySelector(visibility);
    const type = mostrar_password.getAttribute("type");
    const visibility_icon = <HTMLElement>document.querySelector(visibilityIcon);
    if(type == "password"){
      mostrar_password.setAttribute("type","text");
      visibility_icon.classList.add('visibility_icon_active');
    }else{
      mostrar_password.setAttribute("type","password");
      visibility_icon.classList.remove('visibility_icon_active');
    }
  }

  onSubmit(){
    this.Jarwis.actualizarContrasena(this.form).subscribe(
      data =>this.handleResponseCambiarPassword(data),
      error =>this.handleErrorCambiarPassword(error)
     ) 
  }

  handleResponseCambiarPassword(data){
    if(data["error"]){
      this.errorCorreo = data["error"];
    }else if(data["errorAdmin"]){
      location.reload(true);
    }else{
      this.publicformAfterValidation.email = this.form.email;
      this.publicformAfterValidation.password = this.form.password;
      this.Jarwis.login(this.publicformAfterValidation).subscribe(
        data =>this.handleResponse(data),
        error =>this.handleError(error)
      )        
    }
  }
  handleErrorCambiarPassword(error){    
    this.errorTipoCorreo = error.error.errors.email;
    this.errorPasswordMatch =  error.error.errors.password;
  }
  
  handleResponse(data){    
    this.Token.handle(data.access_token,this.typeLocalStorage(data.tipo_usuario),this.convenioLocalStorage(data.convenio));
    this.Auth.changeStatus(true);  
    if(data.tipo_usuario==2){
      this.router.navigate(['/profile']);
    }else{
      this.router.navigate(['/profile/pedido']);
    }     
  }
  handleError(error){
    this.error = error.error.error;
   
  }
  typeLocalStorage(data){
    if( data == 0){
      return "company";
    }else if( data ==  1 ){
      return "person";
    }else if(data == 2){
      return "admin";
    }    
  }
  convenioLocalStorage(data){
    if(data==0){
      return "desactivado";
    }else if(data==1){
      return "activado";
    } 
  }

}
